import { z } from "zod";
import { zObjectId } from "@dobrh-monorepo/core";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";

const requestSchema = z.object({
  categories: z
    .object({
      _id: zObjectId().nullable(),
      name: z.string(),
      type: z.coerce.number().int().min(0).max(2),
      icon: z.string().optional(),
      subCategory: z
        .object({
          _id: zObjectId().nullable(),
          name: z.string(),
          icon: z.string().optional(),
          description: z.string().optional(),
          skills: z.string().array(),
        })
        .array(),
      status: z.number().refine((status) => [0, 1].includes(status), { message: "status must be 0 , 1" }),
    })
    .array(),
});

const responseSchema = z.object({ updatedCategories: z.number(), addedCategories: z.number() });

export default {
  method: HttpMethodEnum.POST,
  paramsType: HttpParamsTypeEnum.BODY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
